/** Backend permission keys. There's no dedicated "comment" permission — "read" gates it. */
export const PERMISSIONS = {
  admin: 'admin',
  post: 'post',
  comment: 'read'
} as const;

export interface AccessLevel {
  label: string;
  permissions: string[];
}

/**
 * Access levels, highest to lowest — index in this array is a level's rank (0 = admin). Each
 * level's `permissions` list ends with the permission that identifies it; admin is the exception,
 * identified solely by `admin`.
 */
export const ACCESS_LEVELS: AccessLevel[] = [
  { label: 'Администратор', permissions: [PERMISSIONS.admin] },
  { label: 'Публикация записей', permissions: [PERMISSIONS.comment, PERMISSIONS.post] },
  { label: 'Комментирование', permissions: [PERMISSIONS.comment] },
  { label: 'Только чтение', permissions: [] }
];

interface HasPermissions {
  permissions?: string[];
}

/** Returns the highest-access rank among these permissions, or the lowest rank if none match. */
export function getAccessLevelRank(permissions: string[]): number {
  if (permissions.includes(PERMISSIONS.admin)) return 0;
  if (permissions.includes(PERMISSIONS.post)) return 1;
  if (permissions.includes(PERMISSIONS.comment)) return 2;
  return 3;
}

/** Sorts members by access level, highest first. */
export function sortByAccessLevel<T extends HasPermissions>(members: T[]): T[] {
  return [...members].sort((a, b) => getAccessLevelRank(a.permissions || []) - getAccessLevelRank(b.permissions || []));
}
